<aside id="sidebar-wrapper" class="scrollbar">
  <div class="sidebar-brand ">
    <a href="javascript:void(0);" (click)="goToBankDashboard()"
      class="d-flex p-3 justify-content-center align-items-center h-100">
      <!-- <img loading="lazy" class="without-toggle-logo" src="assets/images/SprintNXT-white-logo.png"> -->
      <!-- <img loading="lazy" class="toggle-logo" src="assets/images/toggle-logo.png"> -->
      <img loading="lazy" class="without-toggle-logo" src="assets/images/FlowFinance.png">
    </a>

  </div>
  <div class="nav-wrapper f-flex flex-column justify-content-between">
    <!-- [ngClass]="{'accordion ': !_Router.url.includes('add-bank'),'mt-3':!_ConnectBankService.isBankModuleActive}" -->
    <ul class="sidebar-nav" id="child-wrap">
      <li class="nav-item" [ngClass]="{'active': selectedIndex === i,'customMenuItem':item.type == 'custom'}"
        *ngFor="let item of sidemenuData let i= index">
        <ng-container *ngIf="item.type == 'item'">
          <h6 class="ml-3">{{item.name}}</h6>
          <ul class=" p-0">
            <li class="nav-item" *ngFor="let child of item.menu let j= index">
              <!-- @if (child.url == 'dashboard') { -->
              <a class='nav-links' href="javascript:void(0);" (click)="goToBankDashboard(child)"
                [ngClass]="{'active' : _Router.url.includes(child.url??'')}"
                [attr.data-toggle]="child.type == 'collapse'? 'collapse' : ''" [attr.data-target]="'#childmenu'+ i"
                [attr.aria-expanded]="false" (click)="opneModal(child.is_locked, child.name)">
                <i class="{{child.icon}}"></i>
                {{child.name}}
              </a>

              <!-- }@else {

                <a class='nav-links' [routerLink]="child.url"
                  routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{'active' : child.url === url,'dropdown-toggle':child.type == 'collapse'}"
                  [attr.data-toggle]="child.type == 'collapse'? 'collapse' : ''" [attr.data-target]="'#childmenu'+ i"
                  [attr.aria-expanded]="false" (click)="opneModal(child.is_locked, child.name)">
                  <i class="{{child.icon}}"></i>
                  {{child.name}}
                </a>
              } -->
              <!-- <ul class="subchild-menu collapse " *ngIf="child.type == 'collapse'" [id]="'childmenu'+i"
                [attr.data-parent]="'#child-wrap'">
                <li *ngFor="let subchild of child.children">

                  <a class='nav-links' [routerLink]="subchild.url"
                    (click)="opneModal(subchild.is_locked,subchild.name )">
                    <i class="{{subchild.icon}}"></i>
                    <span>{{subchild.name}}</span>
                  </a>
                </li>
              </ul> -->
            </li>
            <div class="border-line my-2"></div>
          </ul>
        </ng-container>
        <!-- <ng-container *ngIf="item.type == 'collapse'">
          <a class='nav-links dropdown-toggle' routerLink="" [attr.data-toggle]="'collapse'"
            [attr.data-target]="'#childmenu'+ i" [attr.aria-expanded]="false"
            [ngClass]=" item.url === url ? 'active' : ''" (click)="opneModal(item.is_locked, item.name)">
            <i class="{{item.icon}}"></i>
            <span>{{item.name}}</span></a>
          <ul class="child-menu collapse " [id]="'childmenu'+i" [attr.data-parent]="'#child-wrap'">
            <li class="nav-item" *ngFor="let child of item.children">
              <a class='nav-links' [routerLink]="child.url" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="opneModal(child.is_locked, child.name)">{{child.name}}</a>
            </li>
          </ul>
        </ng-container>
        <ng-container *ngIf="item.type == 'item'">
          <a class='nav-links' [routerLink]="item.url" routerLinkActive="active" [state]="item.state ?? {}"
            [routerLinkActiveOptions]="{ exact: true }" [ngClass]="item.url === url ? 'active' : ''"
            (click)="opneModal(item.is_locked, item.name)" appRouterLinkCustom [externalLink]="item">
            <i class="{{item.icon}}"></i>
            <span>{{item.name}}</span></a>
        </ng-container>
        <ng-container *ngIf="item.type == 'custom'">
          <a class='nav-links border-0' [routerLink]="item.url" routerLinkActive="active" [state]="item.state ?? {}"
            [routerLinkActiveOptions]="{ exact: true }" [ngClass]="item.url === url ? 'active' : ''"
            (click)="opneModal(item.is_locked, item.name)"
            style="background: url({{item.customBgUrl}});background-repeat: no-repeat; background-size: cover;">
            <ng-container *ngIf="!labelImg">
              <i class="{{item.icon}}"></i>
              <span>{{item.name}}</span>
            </ng-container>
            <img loading="lazy" class="img-fluid" *ngIf="labelImg" [src]="labelImg" alt="">
          </a>
        </ng-container> -->
      </li>
    </ul>

    <!-- <div *ngIf="kycData.kyc_status == 2 && kycData.bank_status == 3 && !_Router.url.includes('add-bank')"
      class=" d-flex justify-content-center addBankAcBox">
      <div class="add-bank d-flex flex-column"><img loading="lazy" class="img-fluid" src="assets/images/ad-account.png">
        <button type="submit" class="btn add-btn"
          [routerLink]="_ConnectBankService.isBankModuleActive?'/'+_ConnectBankService.isBankModuleActive+'/add-bank':'/add-bank'">Add
          Bank Account</button>
      </div>
    </div> -->
  </div>
</aside>